/* A restrained floating movement; stopped offscreen or when motion is reduced. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      const item = animations.get(target);
      if (item) { item.visible = isIntersecting; sync(); }
    });
  });
  function sync() {
    animations.forEach(({animation, visible}) => {
      if (reduced.matches) animation.cancel();
      else if (visible && !document.hidden) animation.play();
      else animation.pause();
    });
  }
  function mount() {
    animations.forEach((item, element) => {
      if (!element.isConnected) { item.animation.cancel(); observer.unobserve(element); animations.delete(element); }
    });
    document.querySelectorAll('.hero-stamp, .chikas-hero__badge').forEach(element => {
      if (animations.has(element)) return;
      const animation = element.animate([
        { transform: 'translateY(0) rotate(-12deg)' },
        { transform: 'translateY(-7px) rotate(-9deg)' },
        { transform: 'translateY(0) rotate(-12deg)' }
      ], { duration: 4800, iterations: Infinity, easing: 'ease-in-out' });
      animation.pause();
      animations.set(element, {animation, visible: false});
      observer.observe(element);
    });
    sync();
  }
  reduced.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(mount));
  const app = document.querySelector('#app');
  if (app) new MutationObserver(mount).observe(app, {childList: true});
  mount();
})();
